export enum types {
  LOCATION_GET_ALL = 'location/getAll',
  LOCATION_CREATE = 'location/create',
  LOCATION_GET = 'location/get',
  LOCATION_UPDATE = 'location/update',
  LOCATION_REMOVE = 'location/remove',
}
